import { ExtensionChipInputOption } from 'src/app/common-components/entity-select/extension/chip-input/extension-phone-number.model';

export interface AddFindMeFollowMeStepData {
   sequence: number | null;

   timeout: number | null;

   extensionsOrPhoneNumbersToDial: ExtensionChipInputOption[];
}

export interface AddFindMeFollowMeStepFormData extends AddFindMeFollowMeStepData {
   fmFmStepId: number;
}

export interface FindMeFollowMeStepItemView extends AddFindMeFollowMeStepFormData {
   isDeleted: boolean;
}

export const findMeFollowMeStepKeyFields: string[] = [
   'fmFmStepId',
   'extensionFmFmId',
   'timeout',
   'sequence',
   'fmFmStepExtensions',
   'fmFmStepPhoneNumbers',
];

export const findMeFollowMeStepExtensionsKeyFields: string[] = ['fmFmStepExtensionId', 'fmFmStepId', 'extensionId'];

export const findMeFollowMeStepPhoneNumbersKeyFields: string[] = ['fmFmStepPhoneNumberId', 'fmFmStepId', 'phoneNumber'];
